import { render, staticRenderFns } from "./PropertyListTable.vue?vue&type=template&id=22ae352d"
import script from "./PropertyListTable.vue?vue&type=script&lang=js"
export * from "./PropertyListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports